import * as React from "react";

import "./highlight-rect.scss";

import {cs} from "@Common/react/chain-services";

import {BgCanvas} from "../../../../common/bg-canvas";
import {toCssPos} from "../../../../common/to-css-pos";

export const HighlightRect = ({rect, frame, getBgColor}) => cs(
    ({}) => (
        <div {...{
            className: "highlight-rect-72o highlight-rect",
            style: {
                ...toCssPos(frame.start),
                ...{width: 0, height: 0},
            },
        }}>

            {BgCanvas({

                rotation: 0,
                start: rect,
                width: rect.width,
                height: rect.height,

                shouldShowColor: (p) => p.x === 0 || p.y===0 || p.x === rect.width - 1 || p.y === rect.height - 1,

                getBgColor,
                ratio: frame.ratio,
            })}
        </div>
    ),
);

